/**
 * Get the base URL for the site for API calls
 * @returns The base URL for the API
 */
export const getAPIURL = (path: string) => {
  const host = window.location.hostname;
  const protocol = window.location.protocol; // Detects 'http:' or 'https:'
  const apiProtocol = protocol === "https:" ? "https" : "http"; // Match React's protocol

  return host.toLowerCase() === "localhost"
    ? `http://localhost:3000/api/${path}` // Always use HTTP for local dev
    : `${apiProtocol}://piviv.co.uk/api/${path}`; // Use HTTP or HTTPS dynamically
};
